import React from 'react';
import CustomerListFunctional from './components/customer-list-functional';

const CustomerList = () => {
	return <CustomerListFunctional />;
};

export default CustomerList;
